var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "automation-block-editor loop" }, [
    _c(
      "div",
      { staticClass: "editor-row customize-editor-minimize" },
      [
        _c("div", { staticClass: "editor-row-title" }, [_vm._v("Loop Type:")]),
        _vm._v(" "),
        _c("CustomPicker", {
          attrs: {
            items: _vm.loopType,
            idKey: "id",
            labelKey: "label",
            title: "Select Loop Type",
          },
          model: {
            value: _vm.clone.mode,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "mode", $$v)
            },
            expression: "clone.mode",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v("Trim Whitespace"),
        ]),
        _vm._v(" "),
        _c("a-switch", {
          model: {
            value: _vm.clone.options.trimWhitespace,
            callback: function ($$v) {
              _vm.$set(_vm.clone.options, "trimWhitespace", $$v)
            },
            expression: "clone.options.trimWhitespace",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        key: "clone.options.iterationCounterStart",
        staticClass: "editor-row customize-editor-minimize",
      },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v("Loop Iteration Counter Start"),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Loop Iteration Counter Start",
            "show-attributes": true,
            "automation-mode": "",
            "show-emoji": false,
          },
          model: {
            value: _vm.clone.options.iterationCounterStart,
            callback: function ($$v) {
              _vm.$set(_vm.clone.options, "iterationCounterStart", $$v)
            },
            expression: "clone.options.iterationCounterStart",
          },
        }),
        _vm._v(" "),
        _c("small", { staticClass: "description" }, [
          _vm._v(
            "\n            A counter value called 'loop_iteration' will be added to each iteration of the loop. Does not affect the\n            data to loop through. Defaults to '0'.\n        "
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        key: "clone.options.maximumIterations",
        staticClass: "editor-row customize-editor-minimize",
      },
      [
        _c("div", { staticClass: "editor-row-title" }, [
          _vm._v("Max Number of Loop Iteration"),
        ]),
        _vm._v(" "),
        _c("TiptapEditor", {
          attrs: {
            placeholder: "Max Number of Loop Iteration",
            "show-attributes": true,
            "show-emoji": false,
            "automation-mode": "",
          },
          model: {
            value: _vm.clone.options.maximumIterations,
            callback: function ($$v) {
              _vm.$set(_vm.clone.options, "maximumIterations", $$v)
            },
            expression: "clone.options.maximumIterations",
          },
        }),
        _vm._v(" "),
        _c("small", { staticClass: "description" }, [
          _vm._v(
            "\n            Set this value to limit the number of loops performed. Data in iterations past the limit will be\n            ignored. A number higher than 500 will be reduced to 500. A number less than 1 will halt this step.\n        "
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _vm.clone.mode === "numbers"
      ? _c(
          "div",
          {
            key: "clone.number.end",
            staticClass: "editor-row customize-editor-minimize",
          },
          [
            _c("div", { staticClass: "editor-row-title" }, [
              _vm._v("Loop Iteration Counter End"),
            ]),
            _vm._v(" "),
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Loop Iteration Counter End",
                "show-attributes": true,
                "show-emoji": false,
                "automation-mode": "",
              },
              model: {
                value: _vm.clone.number.end,
                callback: function ($$v) {
                  _vm.$set(_vm.clone.number, "end", $$v)
                },
                expression: "clone.number.end",
              },
            }),
            _vm._v(" "),
            _c("small", { staticClass: "description" }, [
              _vm._v(
                "\n            Set the iteration number to end the loop at here. Defaults to '1'. Cannot be less than Loop iteration\n            counter start.\n        "
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.clone.mode === "numbers"
      ? _c(
          "div",
          {
            key: "clone.number.increment",
            staticClass: "editor-row customize-editor-minimize",
          },
          [
            _c("div", { staticClass: "editor-row-title" }, [
              _vm._v("Loop iteration counter increment amount"),
            ]),
            _vm._v(" "),
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Loop iteration counter increment amount",
                "show-attributes": true,
                "show-emoji": false,
                "automation-mode": "",
              },
              model: {
                value: _vm.clone.number.increment,
                callback: function ($$v) {
                  _vm.$set(_vm.clone.number, "increment", $$v)
                },
                expression: "clone.number.increment",
              },
            }),
            _vm._v(" "),
            _c("small", { staticClass: "description" }, [
              _vm._v(
                "\n            Set the amount to increment the counter for each iteration of the loop. Defaults to '1'. Cannot be '0'\n            or negative. Must be an whole number.\n        "
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.clone.mode === "line-items"
      ? _c(
          "div",
          { staticClass: "editor-row customize-editor-minimize data-items" },
          [
            _c("div", { staticClass: "editor-row-title" }, [
              _vm._v("Line Item(s) to Loop"),
            ]),
            _vm._v(" "),
            _vm._l(_vm.clone.items || [], function (item, index) {
              return _c("DataItem", {
                key: index,
                on: {
                  delete: function () {
                    return _vm.clone.items.splice(index, 1)
                  },
                },
                model: {
                  value: _vm.clone.items[index],
                  callback: function ($$v) {
                    _vm.$set(_vm.clone.items, index, $$v)
                  },
                  expression: "clone.items[index]",
                },
              })
            }),
            _vm._v(" "),
            _c(
              "SupsisButton",
              { attrs: { small: "", ghost: "" }, on: { click: _vm.addItem } },
              [_vm._v(" Add Item")]
            ),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.clone.mode === "text"
      ? _c(
          "div",
          { staticClass: "editor-row customize-editor-minimize data-items" },
          [
            _c("div", { staticClass: "editor-row-title" }, [
              _vm._v("Text to Loop"),
            ]),
            _vm._v(" "),
            _vm._l(_vm.clone.items || [], function (item, index) {
              return _c("DataItem", {
                key: index,
                on: {
                  delete: function () {
                    return _vm.clone.items.splice(index, 1)
                  },
                },
                model: {
                  value: _vm.clone.items[index],
                  callback: function ($$v) {
                    _vm.$set(_vm.clone.items, index, $$v)
                  },
                  expression: "clone.items[index]",
                },
              })
            }),
            _vm._v(" "),
            (_vm.clone.items || []).length < 1
              ? _c(
                  "SupsisButton",
                  {
                    attrs: { small: "", ghost: "" },
                    on: { click: _vm.addItem },
                  },
                  [_vm._v(" Add Item")]
                )
              : _vm._e(),
          ],
          2
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.clone.mode === "text"
      ? _c(
          "div",
          {
            key: "clone.text.delimiter",
            staticClass: "editor-row customize-editor-minimize",
          },
          [
            _c("div", { staticClass: "editor-row-title" }, [
              _vm._v("Text Delimiter"),
            ]),
            _vm._v(" "),
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Text Delimiter",
                "show-attributes": true,
                "show-emoji": false,
                "automation-mode": "",
              },
              model: {
                value: _vm.clone.text.delimiter,
                callback: function ($$v) {
                  _vm.$set(_vm.clone.text, "delimiter", $$v)
                },
                expression: "clone.text.delimiter",
              },
            }),
            _vm._v(" "),
            _c("small", { staticClass: "description" }, [
              _vm._v(" Supports special characters. Defaults to ',' "),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }